/* @flow */
// typecheck: ignore file
import React from 'react';
import AdminSchoolHeader from 'admin/components/AdminSchoolHeader.jsx';
import AdminSchoolNav from 'admin/components/AdminSchoolNav.jsx';
import AdminBillingBanner from 'admin/components/AdminBillingBanner.jsx';

import './styles/SchoolInfomationLayout.scss';

type Props = {
  children: any,
  params: any,
}

function SchoolInfomationLayout(props: Props) {
  const { params } = props;
  const { schoolId } = params;

  return (
    <div className="SchoolInfomationLayout">
      <AdminSchoolHeader data-test="admin-school-header" schoolId={Number(schoolId)} />
      <div className="SchoolInfomationLayout-content">
        <div className="SchoolInfomationLayout-content-nav">
          <AdminSchoolNav schoolId={Number(schoolId)} />
        </div>
        {props.children}
        <AdminBillingBanner />
      </div>
    </div>
  );
}

export default SchoolInfomationLayout;



// WEBPACK FOOTER //
// ./src/admin/components/SchoolInfomationLayout.jsx